import { 
  Component, 
  Input, 
  Output, 
  EventEmitter, 
  ChangeDetectionStrategy 
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

export interface ButtonConfig {
  id: string;
  label?: string;
  icon?: string;
  tooltip?: string;
  variant?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'help' | 'link' | 'text';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  loading?: boolean;
}

/**
 * Componente Button simplificado - Solo UI, sin arquitectura hexagonal
 */
@Component({
  selector: 'sura-button',
  standalone: true,
  imports: [CommonModule, ButtonModule, TooltipModule],
  template: `
    <p-button
      [pTooltip]="config.tooltip"
      [icon]="config.icon"
      [label]="config.label"
      [loading]="config.loading"
      [disabled]="config.disabled"
      [size]="computedSize"
      [severity]="computedSeverity"
      [text]="config.variant === 'text'"
      [link]="config.variant === 'link'"
      [outlined]="config.variant === 'secondary'"
      [raised]="config.variant === 'primary'"
      (onClick)="handleClick($event)"
    ></p-button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SuraButtonComponent {
  
  @Input({ required: true }) config!: ButtonConfig;
  @Output() buttonClick = new EventEmitter<Event>();

  get computedSize(): 'small' | 'large' | undefined {
    const size = this.config.size;
    return size === 'small' ? 'small' : size === 'large' ? 'large' : undefined;
  }

  get computedSeverity(): 'primary' | 'secondary' | 'success' | 'info' | 'warn' | 'danger' | 'help' | 'contrast' | null | undefined {
    const variant = this.config.variant || 'primary';
    const severityMap: Record<string, 'primary' | 'secondary' | 'success' | 'info' | 'warn' | 'danger' | 'help' | 'contrast'> = {
      'primary': 'primary',
      'secondary': 'secondary', 
      'success': 'success',
      'info': 'info',
      'warning': 'warn',
      'danger': 'danger',
      'help': 'help',
      'link': 'secondary',
      'text': 'secondary'
    };
    return severityMap[variant] || 'primary';
  }

  handleClick(event: Event): void {
    if (!this.config.disabled && !this.config.loading) {
      this.buttonClick.emit(event);
    }
  }
}